import React from 'react';
import { Text, Box } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * 現在の検索条件モーダルヘッダーを表示するコンポーネント
 * @returns {JSX.Element} 現在の検索条件モーダルヘッダーを表示する要素
 */
export const CurrentConditionModalHead = () => {
  return (
    <Box className={styles.currentConditionModal__head}>
      <h2 className={styles.currentConditionModal__title}>現在の検索条件</h2>
      <Text size="12">
        検索条件を保存すると希望する求人の検索が簡単に行えます。検索条件を保存しますか？
      </Text>
    </Box>
  );
};
